import { render, staticRenderFns } from "./el-testGroup.vue?vue&type=template&id=4a1ba69c&scoped=true"
import script from "./el-testGroup.vue?vue&type=script&lang=js"
export * from "./el-testGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1ba69c",
  null
  
)

export default component.exports